import {Component, ElementRef, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {TilesService} from '../../../../../core/services/tiles.service';
import {TilePollingService} from '../../../../../core/services/tile-polling.service';
import {TileBaseComponent} from '../tile-base.component';
import {TileNumberElemSetup} from '../../../../../shared/models/tile-template/interfaces';
import {OptionGroup} from '../../../../../shared/models/option';
import {SimpleAnalogStructure} from '../../../../../shared/models/structure';
import {ShadeToolsService} from '../../../../../core/services/shade-tools.service';
import {AlarmsService} from '../../../../../core/services/alarms.service';
import {TileHistoryService} from '../../../../../core/services/tile-history.service';
import {SessionService} from '../../../../../core/services/session.service';
import {TileAlarmBadgeComponent} from '../../alarm-badge/tile-alarm-badge.component';
import {PopoverMenuComponent} from '../../../popover-menu/popover-menu.component';
import {SpinnerComponent} from '../../../spinner/spinner.component';
import {KeypadComponent} from '../../../keypad/keypad.component';
import {SchedulesViewerComponent} from '../../../schedules-viewer/schedules-viewer.component';
import {FaIconComponent} from '../../../fa-icon/fa-icon.component';
import {TooltipDirective} from '../../../../directives/tooltip/tooltip.directive';
import { PermissionsService } from 'src/core/services/permissions.service';
import { MotiChatService } from 'src/moti/services/moti-chat.service';
import { ViewportIntersectionService } from '../../../../../core/services/viewport-intersection.service';

@Component({
  selector: 'motn-tile-number',
  templateUrl: './tile-number.component.html',
  styleUrls: ['./tile-number.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TileAlarmBadgeComponent,
    PopoverMenuComponent,
    SpinnerComponent,
    KeypadComponent,
    SchedulesViewerComponent,
    TooltipDirective,
    FaIconComponent,
  ],
})
export class TileNumberComponent extends TileBaseComponent implements OnInit {
  @Input() elemDef: TileNumberElemSetup;

  structure: SimpleAnalogStructure;

  changeValueMenuOpen: boolean = false;
  changeValueMenuOptions: OptionGroup;
  keypadOpen: boolean = false;


  constructor(
    protected tilesService: TilesService,
    protected tilePollingService: TilePollingService,
    protected shadeTools: ShadeToolsService,
    protected alarmsService: AlarmsService,
    protected tileHistoryService: TileHistoryService,
    protected permissionsService: PermissionsService,
    protected session: SessionService,
    protected motiChatService: MotiChatService,
    protected elementRef: ElementRef,
    protected viewportService: ViewportIntersectionService,
  ) {
    super(tilesService, tilePollingService, shadeTools, alarmsService, tileHistoryService, permissionsService, session, motiChatService, elementRef, viewportService);
  }


  protected onInit(): void {
    this.structure = this.tile.Structure as SimpleAnalogStructure;
  }


  protected onDestroy(): void {
  }


  showChangeValueMenu(): void {
    if (!this.structure.Writable || this.sendingValue) {
      return;
    }

    try {
      this.changeValueMenuOptions = this.generateNumberOptions();
      this.changeValueMenuOpen = true;
    } catch (e) {
      this.keypadOpen = true;
    }
  }


  hideChangeValueMenu(): void {
    setTimeout(() => {
      this.changeValueMenuOpen = false;
    }, 100);
  }


  incrementDown() {
    let decimals = this.tile.Appearance.Config.Decimal;
    let val = +parseFloat(this.displayValue).toFixed(decimals);
    let inc = this.tile.Appearance.Config.Increment;
    let incDown: number = 0;

    if (val % inc < Number.EPSILON) {
      incDown = +((val - inc).toFixed(decimals));
    } else {
      incDown = +((val - (val % inc)).toFixed(decimals));
    }

    let min = this.tile.Appearance.Config.MinAllowed;
    if (min !== undefined && incDown < min) {
      incDown = min;
    }

    this.sendValue(incDown);
  }


  incrementUp() {
    let decimals = this.tile.Appearance.Config.Decimal;
    let val = +parseFloat(this.displayValue).toFixed(decimals);
    let inc = this.tile.Appearance.Config.Increment;

    let incUp: number = 0;

    if (val % inc < Number.EPSILON) {
      incUp = +((val + inc).toFixed(decimals));
    } else {
      incUp = +((val + inc - (val % inc)).toFixed(decimals));
    }

    let max = this.tile.Appearance.Config.MaxAllowed;
    if (max !== undefined && incUp > max) {
      incUp = max;
    }

    this.sendValue(incUp);
  }


  sendValue(value: number) {
    this.sendAnalogTileValue(+value);
  }


  private generateNumberOptions(): OptionGroup {
    const options: OptionGroup = this.tile.generateNumberOptions(
      this.displayValue,
      this.sendAnalogTileValue.bind(this),
      this.tileValueParser,
    );

    return options;
  }
}
